<template>
  <div>
    <AdvancedPage
        ref="pageRef"
        class="advanced-page-list"
        :actions="actionBtns"
        :operations="operationBtns"
        :extra-grid-options="extraGridOptions"
        :search-before="searchBefore"
        :is-init-query="isInitQuery"
        v-bind="$attrs"
        v-on="$listeners"
        @report="handleReport"
    />
  </div>
</template>
<script>
import {baseGetMenuBtnAwait, getPageBtnsFn, getQuoteMenuBtn} from '@/common/common'
import {gatherBtnSub} from '@/api/custom'

export default {
  components: {},
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    // 右上角操作
    actions: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 表格操作
    operations: {
      type: Array,
      default: () => {
        return []
      }
    }, //是否校验按钮
    isAuthBtn: {
      type: Boolean, default: () => {
        return true
      }
    }, //是否校验操作按钮
    isAuthOptionBtn: {
      type: Boolean, default: () => {
        return true
      }
    },
    // 是否启用明显的border表头
    isObviousHeader: {
      type: Boolean,
      default: true
    },
    isInitQuery: {
      type: Boolean,
      default: false
    },
    searchBtnName: {
      type: String,
      default: "搜索"
    },
    // 页面查询前
    searchBeforePage: {
        type: Function, default: () => {
            return null;
        }
    },
  },
  data() {
    return {
      actionBtns: [],
      operationBtns: [],
      showTable: false, // 按钮权限加载完毕之后展示列表
      btnParamNumbersInfo: [],
      menuName:'',
    }
  },
  computed: {
    extraGridOptions() {
      const options = {
        headerCellClassName: 'custom-header-cell',
        headerAlign: 'center',
        showHeaderOverflow: false,
        rowConfig: {
          isCurrent: true,
        }
      }
      if (this.isObviousHeader) return options
      return undefined
    },

  },
  watch: {
    actions: {
      handler(newVal) {
       // this.init()
       if(this.btnParamNumbersInfo.length){
         this.actionBtns = this.btnValidate(newVal)
       }else{
         this.init()
       }
       
      },
      deep: true
    },
    operations: {
      handler(newVal) {
       // this.init()
       if(this.btnParamNumbersInfo.length){
         this.operationBtns = this.btnValidate(newVal)
       }else{
          this.init()
       }
      },
      deep: true
    }
  },

  created() {
    this.init()
  },
  mounted() {
  },
  destroyed() {

  },
  methods: {
    getQuoteMenuBtn,
    // 页面初始化
    init() {
      const {actions, operations, $route} = this
      this.menuName = $route?.meta?.menuName ?? ''
      this.setActionBtnsFn(actions, operations)
    },
    /*设置按钮权限*/
    async setActionBtnsFn(actions, operations) {
      const allBtns = {
        pageBtns: actions,
        tableBtns: operations,
      }
      let metaObj = this.$route.meta

      const res = await getPageBtnsFn(allBtns, metaObj)
      if (!res) {
        console.error("getPageBtnsFn error is ");
        return;
      }
      this.actionBtns = res.actionBtns
      this.operationBtns = res.operations
      this.curMenuBtns = res.btnParamNumbers
      this.btnParamNumbersInfo = res.btnParamNumbersInfo      
      this.showTable = true  
      if(!this.isAuthBtn){
        this.actionBtns=actions
      }   
      if (!this.isAuthOptionBtn) {
        this.operationBtns = operations;
      }
    },
    refresh() {
      this.$refs.pageRef.refresh()
    },
    export(btn) {
      this.$refs.pageRef.export(btn)
    },
    getCheckboxRecords(){
      return this.$refs.pageRef.$refs.grid.getCheckboxRecords()
    },
    remove(rows){
      this.$refs.pageRef.$refs.grid.remove(rows)
    },
    getRecordset(){
      return this.$refs.pageRef.$refs.grid.getRecordset()
    },
    insert(rows){
      this.$refs.pageRef.$refs.grid.insert(rows)
    },
    getTableData(){
      return this.$refs.pageRef.$refs.grid.getTableData()
    },
    /**
     * @description 埋点上报
     * @param {*} data
     */
    handleReport(data) {
      gatherBtnSub(data)
    },
    /**
     * 查询前事件
     * @param params
     * @returns {Promise<void>}
     */
    searchBefore(params) {
      if (this.isAuthBtn) {
        params['purviewParam'] = baseGetMenuBtnAwait(this.searchBtnName, this.btnParamNumbersInfo, this);
      }

      if(this.searchBeforePage){
        this.searchBeforePage(params)
      }
    },
    setKey(btnName) {
        return this.$md5(this.menuName + btnName)
    },
    btnValidate(btnList){  
      if (!this.isAuthOptionBtn) {
        return btnList
      }
      const lastList = []
      btnList.forEach(item => {
          let key = this.setKey(item.checkName ?? item.name)
          let curInd = this.curMenuBtns.indexOf(key)             
          if(curInd != -1){
            const {btnParamId='',menuId=''} = this.btnParamNumbersInfo[curInd]  
            item.btnParamId = btnParamId
            item.menuId = menuId
            lastList.push(item)
          }
      })
      return lastList
    }
  }
}
</script>
<style lang="less">
.advanced-page {
  position: relative;
  z-index: 1;
  background-color: @primary-color;
  margin: 0 -24px;
  border-top: 1px solid @primary-color;
  font-size: 14px;
  padding: 8px 24px 20px;
  min-height: calc(100vh - 110px);
}

.advanced-page-list {
}

/* 图标！变小！ */
.ant-select-arrow,
.ant-btn {
  .anticon {
    font-size: 14px;
  }
}

/* 全屏隐藏无关内容 */
.full-screen {
  .admin-layout {
    .virtual-side,
    .side-menu,
    .ant-layout-header,
    aside {
      display: none !important;
    }
  }

  .admin-layout-main {
    .advanced-page {
      min-height: 100vh;
    }

    .advanced-page-head > header,
    .advanced-query-assembly,
    .tabs-head {
      display: none;
    }

    .tabs-view-content {
      .page-header {
        display: none;
      }
    }

    .statistics-bar,
    .summary-bar {
      display: none;
    }

    .advanced-query-assembly-container {
      .table-settings-btn-group {
        justify-content: flex-end;
        width: 100%;
        position: relative;

        .exit-full-screen-icon {
          display: block;
        }

        .full-screen-icon {
          display: none;
        }
      }

      .advanced-query-assembly-content {
        display: none;
      }
    }
  }

  .handler-container {
    display: none;
  }
}
</style>
